export default class {
  _idCarpeta
  _idCarpetaPadre
  _nombre
  _descripcion
  _borrable

  constructor() {
    this._nombre = ''
    this._descripcion = ''
    this._borrable = true
  }

  get idCarpeta() {
    return this._idCarpeta
  }

  get idCarpetaPadre() {
    return this._idCarpetaPadre
  }

  get nombre() {
    return this._nombre
  }

  get descripcion() {
    return this._descripcion
  }

  get borrable() {
    return this._borrable
  }

  set idCarpeta(value) {
    this._idCarpeta = value
  }

  set idCarpetaPadre(value) {
    this._idCarpetaPadre = value
  }

  set nombre(value) {
    this._nombre = value
  }

  set descripcion(value) {
    this._descripcion = value
  }

  set borrable(value) {
    this._borrable = value
  }
}